import { useEffect } from 'react';

const DEFAULT_BASE_URL = 'https://omsorgbygg.no';

const upsertMetaTag = (selector, attributes) => {
  let element = document.head.querySelector(selector);

  if (!element) {
    element = document.createElement('meta');
    document.head.appendChild(element);
  }

  Object.entries(attributes).forEach(([key, value]) => {
    element.setAttribute(key, value);
  });
};

export function useSeo({ canonicalPath = '/', description, jsonLd, title }) {
  useEffect(() => {
    const baseUrl = window.location.origin || DEFAULT_BASE_URL;
    const canonicalUrl = new URL(canonicalPath, baseUrl).toString();

    document.title = title;

    upsertMetaTag('meta[name="description"]', {
      content: description,
      name: 'description',
    });

    upsertMetaTag('meta[property="og:title"]', {
      content: title,
      property: 'og:title',
    });

    upsertMetaTag('meta[property="og:description"]', {
      content: description,
      property: 'og:description',
    });

    upsertMetaTag('meta[property="og:url"]', {
      content: canonicalUrl,
      property: 'og:url',
    });

    upsertMetaTag('meta[name="twitter:title"]', {
      content: title,
      name: 'twitter:title',
    });

    upsertMetaTag('meta[name="twitter:description"]', {
      content: description,
      name: 'twitter:description',
    });

    let canonicalLink = document.head.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute('href', canonicalUrl);

    const scriptId = 'omsorgbygg-jsonld';
    const previousScript = document.getElementById(scriptId);
    if (previousScript) {
      previousScript.remove();
    }

    if (jsonLd) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
  }, [canonicalPath, description, jsonLd, title]);
}